import { Component, OnInit } from '@angular/core';
import { catchError, concatMap, of } from 'rxjs';
import { CommonService } from '../../services/common.service';
import { ActivatedRoute } from '@angular/router';
import { DateUtils } from 'src/app/utils/days-utils';
import { DistancePipe } from 'src/shared/pipes/distance.pipe';
@Component({
  selector: 'app-trip-view-dashboard',
  templateUrl: './trip-view-dashboard.component.html',
  styleUrls: ['./trip-view-dashboard.component.scss']

})



export class TripViewDashboardComponent implements OnInit {

  constructor(private commonService: CommonService, private route: ActivatedRoute,private distancePipe: DistancePipe) {
    this.commonService.getTimeZone().subscribe((res) => {

      this.commonService.timeZone = res['timeZone'];
      this.timezone = res['timeZone'];

    })
  }


  attendance: any =
    {
      adhocCount: 0,
      noShowCount: 0,
      totalPlannedEmployeesToBoard: 0,
      plannedemployeesBoarded: 0,
      totalCapacity: 0,
      totalPlannedEmployees: 0
    }
  loader: any = true;
  response: any;
  timezone = 'Asia/Manila';


  ngOnInit(): void {
    this.getSideViewData()
    setInterval(() => {
      this.getSideViewData();
    }, 60000);


  }


  getSideViewData() {
    this.commonService.getTripDetails(this.commonService.tripId).
    pipe(
      concatMap((res:any) =>{
        this.commonService.response = res
        this.response = res
        console.log("hi", res);
        const allEmployees: any = res.tripDetails.employees.map((obj: { name: any, employeeId: any, gender: any, plannedPickupLocation: any, plannedPickupTime: any, plannedDropTime: any, distanceTravelled: any,fdTravelledDistance:any, phoneNumber: any, driverReportingTime: any, noShow: any, adhoc: any, actualPickupTime: any, actualDropTime: any, actualPickupLocation: any, shuttleEmpSignInType: any,
          cabIn?: any,
          cabOut?: any,
          proximityHitIn?: any,
          proximityHitOut?: any
        , noShowMarkedBy: any, noShowTimeStamp: any}) =>
        ( 
          {
            name: obj?.name,
            Id: obj.employeeId,
            location: !!obj.plannedPickupLocation?.address ? obj.plannedPickupLocation?.address : obj.actualPickupLocation?.address,
            actualPickupLocation: obj.actualPickupLocation,
            plannedPickupLocation: obj.plannedPickupLocation,
            landmark: obj.plannedPickupLocation?.landmark,
            actualPickupTime: obj.actualPickupTime,
            signIn: obj.actualPickupTime ? DateUtils.formatTimeWithZone(obj.actualPickupTime, this.timezone,'HH:mm'):'--' ,
            signOut:  DateUtils.formatTimeWithZone(obj.actualDropTime, this.timezone,'HH:mm') ,

            reportTime: DateUtils.formatTimeWithZone(obj.driverReportingTime, this.timezone,'HH:mm'),
            distance: this.distancePipe.transform(obj.distanceTravelled),
            fdTravelledDistance: this.distancePipe.transform(obj?.fdTravelledDistance),
            gender: obj.gender,
            adhoc: obj.adhoc,
            noShow: obj.noShow,
            phone: obj.phoneNumber,
            empStatus: obj.shuttleEmpSignInType,
            plannedPickupTime: DateUtils.formatTimeWithZone(obj.plannedPickupTime, this.timezone,'HH:mm'),
            cabIn:DateUtils.formatTimeWithZone(obj?.cabIn, this.timezone),
            cabOut:DateUtils.formatTimeWithZone(obj?.cabOut, this.timezone),
            proximityHitIn:DateUtils.formatTimeWithZone(obj?.proximityHitIn, this.timezone),
            proximityHitOut:DateUtils.formatTimeWithZone(obj?.proximityHitOut, this.timezone),  
            geocord: !!obj.plannedPickupLocation ? obj.plannedPickupLocation['geocord'] : '',
            noShowMarkedBy: obj.noShowMarkedBy,
            noShowTimeStamp: obj.noShowTimeStamp
          }
        ));
       
        console.log('employees', allEmployees);
        let countEmpNotSignOut = 0;
        let countEmpSignOut = 0;
        let countFemale = 0;
        allEmployees.forEach(emp => {
          console.log('actual drop', emp.actualDropTime);
  
          if (emp.signOut === '--' && !emp.noShow) {
            countEmpNotSignOut++;
            if (emp.gender === 'Female') {
              countFemale++;
            }
          } else if (!emp.noShow) {
            countEmpNotSignOut++;
          }
  
        });
        if(allEmployees.length===0){
          this.commonService.womenTravellingAlone$.next(false);
        }
        else if (countEmpNotSignOut === countFemale) {
          this.commonService.womenTravellingAlone$.next(true);
        } else {
          this.commonService.womenTravellingAlone$.next(false);
        }
  
  
        this.commonService.employeeDetails$.next(allEmployees)
        let adhocCount = 0;
        let noShowCount = 0;
        let totalPlannedEmployeesToBoard = 0;
        let plannedemployeesBoarded = 0;
        let totalPlannedEmployees = 0;
  
        for (let i = 0; i < allEmployees.length; i++) {
          if (allEmployees[i].adhoc === true) {
            adhocCount++;
          }
          if (allEmployees[i].noShow === true && allEmployees[i].plannedPickupLocation !== null && allEmployees[i].actualPickupLocation === null) {
            noShowCount++;
          }
          if (allEmployees[i].adhoc === false && allEmployees[i].noShow === false && allEmployees[i].actualPickupLocation === null && allEmployees[i].plannedPickupLocation !== null) {
            totalPlannedEmployeesToBoard++;
          }
          if (allEmployees[i].actualPickupLocation !== null && allEmployees[i].adhoc === false && allEmployees[i].plannedPickupLocation !== null) {
            plannedemployeesBoarded++;
          }
          if (allEmployees[i].plannedPickupLocation !== null) {
            totalPlannedEmployees++;
          }
        }
        this.attendance.adhocCount = adhocCount
        this.attendance.noShowCount = noShowCount
        this.attendance.totalPlannedEmployeesToBoard = totalPlannedEmployeesToBoard;
        this.attendance.plannedemployeesBoarded = plannedemployeesBoarded
        this.attendance.totalCapacity = this.response.tripDetails.vehicle.vehicleType?.maxCapacity
        this.attendance.totalPlannedEmployees = totalPlannedEmployees
        this.commonService.attendance$.next(this.attendance)
  
        const employeesByActualLocalityId = res.tripDetails.employees.reduce((acc: any, emp: any) => {
          console.log("Actual loaction 1", acc);
          if (emp.actualPickupLocation != undefined) {
            const actualLocalityId = emp.actualPickupLocation.locationId;
            const plannedLocalityId = emp.plannedPickupLocation?.locationId;
            const localityId = emp.actualPickupLocation?.locationId;
            console.log("Actual loaction 2", acc);
  
            if (actualLocalityId !== plannedLocalityId) {
              if (acc[localityId] === undefined) {
                acc[localityId] = [];
              }
              acc[localityId].push(emp);
            }
          }
          return acc;
  
        }, {});
  
        console.log("ALL EMPLOYEES WITH ACTUAL LOCALITY ID", employeesByActualLocalityId);
  
        const employeesByPlannedLocality = res.tripDetails.employees.reduce((acc: any, emp: any) => {
          const localityId = emp.plannedPickupLocation?.locationId;
          if (acc[localityId] === undefined) {
            acc[localityId] = [];
          }
          acc[localityId].push(emp);
          return acc;
        }, {});
  
        console.log("ALL EMPLOYEES WITH PLANNED LOCALITY ID ", employeesByPlannedLocality);
  
  
        const shuttleStopsWithEmployees =   Array.isArray(res?.tripDetails?.shuttleStops) ? res.tripDetails.shuttleStops.map((stop: any, index: number) => {
  
          const employeesForStop = employeesByPlannedLocality[stop.nativeId] ?? [];
          const employeesByActualLocality = employeesByActualLocalityId[stop.nativeId] ?? [];
  
          // let employeeForPlannedStop=[];
          // allEmployees.forEach((emp)=>{
          //   if(emp.geocord===stop.geocord){
          //      employeeForPlannedStop.push(emp);
          //   }
          // })
          // console.log('employeePlannedStops',employeeForPlannedStop);
  
  
          console.log("ALL Emp Planned to Stop ", employeesForStop);
  
          const simplifiedEmployees = employeesForStop.map((emp: any) => ({
            employeeId: emp.employeeId,
            stwId: emp.stwId,
            name: emp?.name,
            actualPickupTime: emp.actualPickupTime,
            actualDropTime: emp.actualDropTime,
            gender: emp.gender,
            localityId: emp.plannedPickupLocation.locationId,
            isPicked: (emp.actualPickupTime != 0 ? true : false),
            plannedPickupTime: emp.plannedPickupTime,
            plannedDropTime: emp.plannedDropTime,
            noShow: emp.noShow,
            plannedPickUpLocation: emp.plannedPickupLocation?.address,
            plannedDropLocation: emp.plannedDropLocation?.address,
            StopActualArrivalTime: stop.actualArrivalTime,
            signIn: DateUtils.formatTimeWithZone(emp.actualPickupTime, this.timezone,"HH:mm"),
            signOut: DateUtils.formatTimeWithZone(emp.actualDropTime, this.timezone,"HH:mm"),
            adhoc: emp.adhoc,
            plannedLocalityId: emp.plannedPickupLocation.locationId,
            // actualLocalityId:emp.actualPickupLocation.locationId ?? null, // null check
            empStatus: emp.shuttleEmpSignInType,
            phoneNumber: emp.phoneNumber,
            geocord: emp.geocord
          }));
          console.log("employee for debugging", simplifiedEmployees);
  
          const numberOfEmployeestoBoard = simplifiedEmployees.filter((emp: any) => emp.adhoc === false).length;;
          const numberOfPickedEmployees = simplifiedEmployees.filter((emp: any) => emp.isPicked).length;
          const totalNumberOfNoShowEmployees = simplifiedEmployees.filter((emp: any) => emp.noShow).length;
          // const unPlannedEmployeesOnStopStatus = simplifiedEmployees.filter((emp: any) => emp.actualLocalityId === stop.localityId && (emp.empStatus === 'Adhoc' || emp.empStatus === 'unplanned'));
  
          let adhocEmployees = [];
          allEmployees.forEach(emp => {
            console.log('emp adjhocv', emp, stop);
  
            if (emp.adhoc === true && emp.actualPickupLocation.locationId === stop.nativeId) {
              adhocEmployees.push(emp);
            }
          })
  
          return {
            ...stop,
            index: index + 1,
            employees: simplifiedEmployees,
            numberOfEmployeestoBoard: numberOfEmployeestoBoard,
            numberOfEmployeesBoarded: numberOfPickedEmployees,
            totalNumberOfNoShowEmployees: totalNumberOfNoShowEmployees,
            formattedPlannedArrivalTime: DateUtils.formatTimeWithZone(stop.plannedArrivalTime, this.timezone,"HH:mm"),
            formattedActualArrivalTime: DateUtils.formatTimeWithZone(stop.actualArrivalTime, this.timezone, 'HH:mm'),
             unPlannedEmployeesOnStop: employeesByActualLocality,
            adhocEmployees: adhocEmployees
          };
        }) : [];
  
        //  shuttleStopsWithEmployees[0].employees.push( shuttleStopsWithEmployees[0].employees[0]);
  
        this.commonService.busStopsDetails$.next(shuttleStopsWithEmployees)
        console.log("shutlle stops", shuttleStopsWithEmployees);
  
        // Subscribing Driver Actions 
        this.commonService.getDriverActions(this.response.tripDetails.tripUuid,this.commonService.tripId).subscribe((res:any)=>
        {
          this.commonService.driverActions$.next(res)
        })
       return this.commonService.getTicketDetails()
       .pipe(
         catchError((error) => {
           console.error('Error fetching ticket details:', error);
           // Returning an empty observable so the next steps continue
           return of([]);
         })
       );
      } )
    ).subscribe((res:any) => {
      let ticketArray = []
      let ticketDetails = res?.data
      try{
        for(let item of ticketDetails){
          const obj =  {
            ticketType:item["ticketType"].replace('_',' '),
            ticketId:item["ticketId"],
            ticketUrl:item['URL']
          }
          ticketArray.push(obj)
        }
      }
      catch(e){
        ticketArray = []
      }
      this.commonService.ticketDetails = ticketArray
      this.loader = false
    })
  }



}
